'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiAnchor = function TiAnchor(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 22.5c-0.9 0-1.7 0.7-1.7 1.7 0 4-2.8 7.4-6.6 8.1v-12.3h6.6c1 0 1.7-0.7 1.7-1.7s-0.7-1.6-1.7-1.6h-6.6v-2c1.9-0.7 3.3-2.5 3.3-4.7 0-2.8-2.2-5-5-5s-5 2.2-5 5c0 2.2 1.4 4 3.3 4.7v2h-6.6c-1 0-1.7 0.7-1.7 1.6s0.7 1.7 1.7 1.7h6.6v12.3c-3.8-0.7-6.6-4.1-6.6-8.1 0-1-0.8-1.7-1.7-1.7s-1.7 0.7-1.7 1.7c0 6.4 5.3 11.6 11.7 11.6s11.7-5.2 11.7-11.6c0-1-0.8-1.7-1.7-1.7z m-10-14.2c0.9 0 1.7 0.8 1.7 1.7s-0.8 1.7-1.7 1.7-1.7-0.8-1.7-1.7 0.8-1.7 1.7-1.7z' })
        )
    );
};

exports.default = TiAnchor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/anchor.js
// module id = 3512
// module chunks = 0